var modalContext = null;

$(document).on('switchChange.bootstrapSwitch', '.apertura', function (event, state) {
    var e = $(this);
    var tipo = e.data('apertura');
    var id_mst_recurso = e.closest('li').data('id_mst_recurso');

    if (tipo == 'apertura_luz' && state == true) {
        show_modal_tiempo_luz(id_mst_recurso, state, tipo, e, false);
    } else {
        e.closest('li').find('.alert').toggleClass('hidden');
        postApertura(id_mst_recurso, state, tipo);
    }
});

// Función para actualizar el color de fondo del select según el estado
function update_triestado_color(select) {
    var state = $(select).val();
    var colors = {
        '-1': '#d9534f', // Rojo para OFF
        '0': '#4B5265',  // Gris para AUTO
        '1': '#5cb85c'   // Verde para ON
    };
    $(select).css('background-color', colors[state] || '#fff');
    $(select).css('color', '#fff');
}

// Inicializar colores de los selects triestado al cargar la página
$(document).ready(function() {
    $('.apertura.triestado').each(function() {
        update_triestado_color(this);        
        actualizar_alertas_triestado(this);
    });
});

// Manejo del select de tres estados (OFF=-1, AUTO=0, ON=1) para luz
$(document).on('change', '.apertura.triestado', function (event) {
    var e = $(this);
    var state = $(this).val();
    var tipo = e.data('apertura');
    var id_mst_recurso = e.closest('li').data('id_mst_recurso');
    var estat_original = e.data('estado');
    
    // Actualizar color de fondo según el estado
    update_triestado_color(this);
    actualizar_alertas_triestado(this);
   
    if (tipo == 'apertura_luz' && state != '0') {
        show_modal_tiempo_luz(id_mst_recurso, state, tipo, e, estat_original);
    } else {
        postApertura(id_mst_recurso, state, tipo);
        if (tipo == 'apertura_luz' && state == '0') {
            e.data('estado', state);
            window.location.reload();
        }
    }
});

function actualizar_alertas_triestado(select){
     // Mostrar/ocultar alerta según el estado inicial
     var state = $(select).val();
     if (state == '0') { // AUTO (0) 
        $(select).closest('li').find('.alert').addClass('hidden');            
     } else { // ON(1) o OFF(-1)
        $(select).closest('li').find('.alert').removeClass('hidden');
     }
}

$(document).on('click', '.apertura', function (event, state) {
    var e = $(this);
    if (e.hasClass('bootstrap-switch') || e.hasClass('triestado')) return; 

    var id_mst_recurso = e.closest('li').data('id_mst_recurso');
    postApertura(id_mst_recurso,'true','aperturaacceso');

    var res = $('#pista' + id_mst_recurso);
    res.removeClass('hidden');
    setTimeout ('var idRecursoInner = ' + id_mst_recurso + '; var res = $(\'#pista\' + idRecursoInner); res.addClass(\'hidden\');', 5000);
});

function postApertura(id_mst_recurso,state,tipo, minutos){
    //tipo: apertura_luz, aperturaacceso
    //state puede ser: true/false (para checkbox) o -1/0/1 (para select triestado: -1=OFF, 0=AUTO, 1=ON)
    var data = {
        'id_mst_recurso':id_mst_recurso,
        'apertura':state,
        'tipo':tipo
    };
    if (minutos) {
        data.minutos = minutos;
    }
    $.post('/domotica/apertura',data,function(){

    });
}

function show_modal_tiempo_luz(id, state, tipo, el, estat_original) {
    modalContext = {
        id: id,
        state: state,
        tipo: tipo,
        el: el,
        estat_original: estat_original
    };
    $('#modal_tiempo_luz').modal('show');
}

$(document).on('click', '#btn_confirmar_tiempo_luz', function () {
    if (!modalContext) return;
    var minutos = $('#minutos_luz').val();
    postApertura(modalContext.id, modalContext.state, modalContext.tipo, minutos);
    
    if (modalContext.el.is('select')) {
        modalContext.el.data('estado', modalContext.state);
    }
    
    if (modalContext.el.hasClass('bootstrap-switch')) {
        modalContext.el.closest('li').find('.alert').toggleClass('hidden');
    }
    window.location.href = window.location.href;
   

});

$(document).ready(function() {
    $('#modal_tiempo_luz').on('hidden.bs.modal', function () {
        if (modalContext) {            
            if (modalContext.el.hasClass('bootstrap-switch')) {
                modalContext.el.bootstrapSwitch('state', !modalContext.state, true);
            } else if (modalContext.el.is('select')) {
                modalContext.el.val(modalContext.estat_original);
                update_triestado_color(modalContext.el);
                actualizar_alertas_triestado(modalContext.el);
            }
            modalContext = null;
        }
    });
});

var domotica = {
   estado_instalacion: {
       update: function (estado) {
           $.post('/domotica/domotica_estado_instalacion', {estado: estado},function(){
               $("#domotica_estado_instalacion .panel-heading").notify(
                   Lang.get('msg.Operacio_realitzada_correctament'),
                   {position: "bottom", className: 'success'}
               );
           });


       }
   },
    parametroForzado:{
       update: function(param,valor){
           $.post('/domotica/domoticaParametroForzado', {param: param,valor:valor},function(){
               $(".parametroForzado."+param+" .panel-heading").notify(
                   Lang.get('msg.Operacio_realitzada_correctament'),
                   {position: "bottom", className: 'success'}
               );
           });
       }
    },
    avisoEmailCambioEmail:{
      update:function(){
          axios.post('/domotica/avisoInternetErrorCambiaEmail', {
              domotica_configuracion_emails: $("#domotica_configuracion_emails").val()
          }).then(function (res) {
              $("#domotica_configuracion_emails_btn").notify(
                  res.data.msg,
                  {position: "top", className: res.data.error == 1 ? 'error' : 'success'}
              );
          });
      }
    }
}

$(document).on('click','#DOMOTICA_ALARMA_ENVIO_MAIL .btn-success',function(){
    var self = this;
    $.post('domotica/domoticaAlarmaEnvioMail',{valor:$("#DOMOTICA_ALARMA_ENVIO_MAIL .valor").val()},function(res){
        if (res.status==1){
            $(self).notify(
                Lang.get('msg.Operacio_realitzada_correctament'),
                {position: "top", className: 'success'}
            );
        }
    })
});


